// UI z 序（depth）單一真相來源
// 各 UI 元件原本各自用 `const X_DEPTH = 80 // 高於回合手勢(70)` 的方式硬寫數字並在註解
// 互相引用對方的值，改一個要手動同步全部。改成集中在這裡：由低到高一眼看完整層序，
// 各元件的本地具名常數改為引用 UIDepth.*（保留本地命名與說明，但數字只在這裡定義）。
//
// 註：此表只收「直接 add 到 scene 的物件」之全域 depth。容器內的相對 depth
// （如 CFlowerBanner 花瓣/徽章相對花帶容器、CTenpaiPeek 內部疊層）仍留在各元件本地。

export const UIDepth = {
  // ---- 桌面底層（負值，所有牌面與 UI 之下）----
  TableGradient: -100, // 桌面漸層背景
  TableBorder: -99, // 桌面邊框
  TableLight: -98, // 桌燈光線（中央暖光 + 四角暗角）
  WindBadge: -50, // 風位徽章（東南西北字）
  TableInfo: -40, // 中央局數 / 底台資訊面板

  // ---- 牌面層 ----
  Tile: 0, // 牌 sprite 預設 depth
  HandFlowerStackTop: 20, // flowerFirstOnTop 時第一張花的 depth（後續每張遞減 1，仍 > Tile）

  // ---- 牌面之上的提示 / 互動層 ----
  FlowerFlyer: 50, // 補花飛行牌
  DealerIcon: 52, // 莊家「莊」icon
  ActionBar: 60, // 動作按鈕條
  DrawFlyer: 60, // 摸牌飛行牌（與 ActionBar 同層，刻意一致）
  PlayerRiseTile: 60, // 本家出牌升起的放大牌（同上）
  TurnHand: 70, // 回合指示手勢
  DiscardAnnounce: 78, // 捨牌宣告字（吃/碰/槓）
  ActionIcon: 80, // 動作浮標 icon
  TurnTimer: 80, // 倒數計時器（與 ActionIcon 同層）
  PlayerStatus: 90, // AI 思考／本家代打持續狀態

  // ---- 全畫面覆蓋層 ----
  TenpaiPeek: 100, // 聽牌瞇牌動畫（手掌/牌/拇指由此往上 +1/+2/+3）
  TenpaiBanner: 150, // 宣告「聽」橫幅
  EntranceHint: 200, // 入場提示
  FlowerBanner: 260, // 補花中央橫幅（最上層）
  GameDrawCeremony: 300, // 流局儀式（與胡牌儀式互斥）
  WinCeremony: 300, // 自摸／胡牌／放槍儀式與「點擊繼續」輸入遮罩
  CelebrationBurst: 301, // 胡／自摸／槓的慶祝粒子（蓋過儀式畫面，仍在暫停對話框之下）
  PauseDialog: 400, // 牌局暫停與設定對話框
} as const;

export type TUIDepth = (typeof UIDepth)[keyof typeof UIDepth];
